var map = {
	"./ar.json": 38463,
	"./cn.json": 24445,
	"./de.json": 77399,
	"./es.json": 7144,
	"./fr.json": 61868,
	"./id.json": 57317,
	"./ir.json": 52775,
	"./it.json": 77397,
	"./jp.json": 33274,
	"./pt.json": 44176,
	"./ru.json": 44537,
	"./tr.json": 72474
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49823;